// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.biweekly-guide {
  min-height: 100vh;
  background: #f8f8f8;
  padding: 20px 0;
  font-family: 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
  font-size: 16px;
}

.guide-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #212121;
  text-decoration: none;
  font-size: 16px;
  margin-bottom: 20px;
  font-weight: 500;
}

.guide-back:hover {
  color: #1a73e8;
}

.guide-container.document-style {
  max-width: 1800px;
  margin: 40px auto 0 auto;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 6px 32px 0 rgba(60, 72, 88, 0.10), 0 1.5px 4px 0 rgba(60, 72, 88, 0.06);
  padding: 32px 24px 48px 24px;
  line-height: 1.8;
}

.manual-title {
  text-align: center;
  color: #212121;
  font-size: 3rem;
  margin-bottom: 32px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.section-heading {
  color: #212121;
  font-size: 2.3rem;
  margin-bottom: 18px;
  font-weight: 600;
}

.section-description {
  font-size: 1.3rem;
  color: #616161;
  margin-bottom: 32px;
}

.page-title {
  color: #1a73e8;
  font-size: 1.6rem;
  margin: 36px 0 18px 0;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.subsection-title {
  color: #1a73e8;
  font-size: 1.4rem;
  margin: 24px 0 16px 0;
  font-weight: 600;
}

.score-block {
  margin-bottom: 28px;
}

.score-question {
  color: #212121;
  font-size: 1.3rem;
  margin-bottom: 8px;
  font-weight: 600;
}

.score-list {
  margin: 0 0 12px 0;
  padding-left: 28px;
  font-size: 1.2rem;
}

.score-list li {
  margin-bottom: 8px;
  line-height: 1.7;
}

/* Style for paragraphs after score questions (like "Why is this graph important?" sections) */
.score-question + p {
  font-size: 1.2rem;
  line-height: 1.7;
  color: #616161;
  margin-bottom: 16px;
}

/* Style for all paragraphs in the guide to ensure consistent sizing */
.guide-container.document-style p {
  font-size: 1.2rem;
  line-height: 1.7;
  color: #616161;
  margin-bottom: 16px;
}

.highlight {
  background: #e8f0fe;
  color: #1a73e8;
  font-weight: 600;
  padding: 0 4px;
  border-radius: 3px;
}

.note {
  display: inline-block;
  background: #e0f2f1;
  color: #00796b;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 1.1rem;
  margin-top: 8px;
}

@media (max-width: 1800px) {
  .guide-container.document-style {
    max-width: 98vw;
    padding: 24px 4vw 36px 4vw;
  }
  .guide-img {
    width: 100%;
    max-width: 100%;
  }
}

@media (max-width: 900px) {
  .guide-container.document-style {
    padding: 24px 4vw 32px 4vw;
  }
  .manual-title {
    font-size: 2.4rem;
  }
  .section-heading {
    font-size: 1.6rem;
  }
  .guide-img {
    width: 100%;
    max-width: 100%;
  }
}

@media (max-width: 600px) {
  .guide-container.document-style {
    padding: 10px 2vw 20px 2vw;
  }
  .manual-title {
    font-size: 1.6rem;
  }
  .section-heading {
    font-size: 1.3rem;
  }
  .page-title {
    font-size: 1.2rem;
  }
  .subsection-title {
    font-size: 1.1rem;
  }
  .score-question {
    font-size: 1.1rem;
  }
  .score-list {
    font-size: 1.05rem;
  }
  /* Update paragraph sizes for mobile */
  .guide-container.document-style p {
    font-size: 1.05rem;
  }
  .score-question + p {
    font-size: 1.05rem;
  }
  .guide-img {
    width: 100%;
    max-width: 100%;
  }
}

/* Google Translate Widget Styles */
.translate-section {
  margin-bottom: 20px;
  text-align: center;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 10px;
  border: 1px solid #e9ecef;
}

.translate-section #google_translate_element {
  display: inline-block;
}

.translate-section .goog-te-gadget {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
  font-size: 14px !important;
}

.translate-section .goog-te-gadget .goog-te-combo {
  padding: 8px 12px;
  border: 2px solid #1a73e8;
  border-radius: 6px;
  background: white;
  color: #212121;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  transition: all 0.3s ease;
}

.translate-section .goog-te-gadget .goog-te-combo:hover {
  border-color: #00796b;
  box-shadow: 0 2px 8px rgba(26, 115, 232, 0.2);
}

.translate-section .goog-te-banner-frame {
  display: none !important;
}

.translate-section .goog-te-menu-value {
  color: #212121 !important;
}

/* Language Selector Styles */
.language-selector {
  margin-bottom: 30px;
  text-align: center;
}

.language-tabs {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

.language-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border: 2px solid #e9ecef;
  background: #efefef;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
  font-weight: 500;
  color: #616161;
  min-width: 120px;
  justify-content: center;
}

.language-tab:hover {
  border-color: #1a73e8;
  color: #1a73e8;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.2);
}

.language-tab.active {
  background: #1a73e8;
  border-color: #1a73e8;
  color: white;
  box-shadow: 0 4px 15px rgba(26, 115, 232, 0.3);
}

.language-tab .flag {
  font-size: 1.2rem;
}

.language-tab .lang-name {
  font-weight: 600;
}

.guide-title {
  text-align: center;
  color: #212121;
  font-size: 2.5rem;
  margin-bottom: 20px;
  font-weight: 700;
}

.guide-intro {
  text-align: center;
  font-size: 1.2rem;
  color: #616161;
  margin-bottom: 40px;
  padding: 20px;
  background: #fff;
  border-radius: 10px;
  border-left: 4px solid #1a73e8;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.guide-section {
  margin-bottom: 40px;
  padding: 30px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e9ecef;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.guide-section:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.guide-section h2 {
  color: #212121;
  font-size: 1.8rem;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 3px solid #1a73e8;
  display: inline-block;
}

.graph-explanation h3 {
  color: #212121;
  font-size: 1.3rem;
  margin: 20px 0 10px 0;
  font-weight: 600;
}

.graph-explanation p {
  color: #616161;
  font-size: 1.1rem;
  margin-bottom: 15px;
}

.graph-explanation ul {
  list-style: none;
  padding-left: 0;
}

.graph-explanation ul li {
  padding: 8px 0;
  color: #616161;
  font-size: 1rem;
  position: relative;
  padding-left: 25px;
}

.graph-explanation ul li:before {
  content: "•";
  color: #1a73e8;
  font-weight: bold;
  font-size: 1.5rem;
  position: absolute;
  left: 0;
  top: 5px;
}

.graph-explanation ul li strong {
  color: #212121;
  font-weight: 600;
}

.tips-section {
  background: #00796b;
  color: white;
  padding: 25px;
  border-radius: 10px;
  margin-top: 20px;
}

.tips-section ul {
  list-style: none;
  padding-left: 0;
}

.tips-section ul li {
  padding: 10px 0;
  font-size: 1.1rem;
  position: relative;
  padding-left: 30px;
}

.tips-section ul li:before {
  content: "💡";
  position: absolute;
  left: 0;
  top: 8px;
}

.tips-section ul li strong {
  font-weight: 600;
  color: #fff;
}

.guide-footer {
  margin-top: 40px;
  padding: 25px;
  background: #e8f0fe;
  border-radius: 10px;
  border-left: 4px solid #1a73e8;
  text-align: center;
}

.guide-footer p {
  color: #1a73e8;
  font-size: 1.1rem;
  margin: 0;
}

.guide-footer strong {
  color: #212121;
}

/* Responsive Design */
@media (max-width: 768px) {
  .guide-container {
    padding: 20px;
    margin: 10px;
  }
  
  .guide-title {
    font-size: 2rem;
  }
  
  .guide-section {
    padding: 20px;
  }
  
  .guide-section h2 {
    font-size: 1.5rem;
  }
  
  .graph-explanation h3 {
    font-size: 1.2rem;
  }

  .language-tabs {
    flex-direction: column;
    align-items: center;
  }

  .language-tab {
    width: 200px;
  }

  .translate-section {
    padding: 10px;
  }
}

@media (max-width: 480px) {
  .biweekly-guide {
    padding: 10px;
  }
  
  .guide-container {
    padding: 15px;
  }
  
  .guide-title {
    font-size: 1.8rem;
  }
  
  .guide-intro {
    font-size: 1rem;
    padding: 15px;
  }

  .language-tab {
    width: 180px;
    padding: 10px 15px;
    font-size: 0.9rem;
  }

  .language-tab .flag {
    font-size: 1rem;
  }

  .translate-section .goog-te-gadget .goog-te-combo {
    font-size: 12px;
    padding: 6px 10px;
  }
}

.graph-img {
    display: block;
    margin: 32px auto;
    width: 600px;
    max-width: 100%;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(60,72,88,0.10);
}

.color-swatch {
  display: inline-block;
  width: 28px;
  height: 16px;
  border-radius: 4px;
  margin: 0 8px 0 6px;
  vertical-align: middle;
  box-shadow: 0 1px 4px rgba(60,72,88,0.10);
  border: 1px solid #e0e0e0;
}
.dark-blue { background: #1a237e; }
.light-blue { background: #90caf9; }
.faint-blue { background: #e3f2fd; }
.orange-brown { background: #bcaaa4; }
.gray-dash { background: repeating-linear-gradient(90deg, #bdbdbd, #bdbdbd 6px, #fff 6px, #fff 12px); } `, "",{"version":3,"sources":["webpack://./src/components/BiWeeklyGuide/BiWeeklyGuide.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,6DAA6D;EAC7D,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,qFAAqF;EACrF,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,8FAA8F;AAC9F;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,sEAAsE;AACtE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA,sCAAsC;EACtC;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uEAAuE;EACvE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;EACzC,yBAAyB;AAC3B;AACA,aAAa,mBAAmB,EAAE;AAClC,cAAc,mBAAmB,EAAE;AACnC,cAAc,mBAAmB,EAAE;AACnC,gBAAgB,mBAAmB,EAAE;AACrC,aAAa,uFAAuF,EAAE","sourcesContent":[".biweekly-guide {\n  min-height: 100vh;\n  background: #f8f8f8;\n  padding: 20px 0;\n  font-family: 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;\n  font-size: 16px;\n}\n\n.guide-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #212121;\n  text-decoration: none;\n  font-size: 16px;\n  margin-bottom: 20px;\n  font-weight: 500;\n}\n\n.guide-back:hover {\n  color: #1a73e8;\n}\n\n.guide-container.document-style {\n  max-width: 1800px;\n  margin: 40px auto 0 auto;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 6px 32px 0 rgba(60, 72, 88, 0.10), 0 1.5px 4px 0 rgba(60, 72, 88, 0.06);\n  padding: 32px 24px 48px 24px;\n  line-height: 1.8;\n}\n\n.manual-title {\n  text-align: center;\n  color: #212121;\n  font-size: 3rem;\n  margin-bottom: 32px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.section-heading {\n  color: #212121;\n  font-size: 2.3rem;\n  margin-bottom: 18px;\n  font-weight: 600;\n}\n\n.section-description {\n  font-size: 1.3rem;\n  color: #616161;\n  margin-bottom: 32px;\n}\n\n.page-title {\n  color: #1a73e8;\n  font-size: 1.6rem;\n  margin: 36px 0 18px 0;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.subsection-title {\n  color: #1a73e8;\n  font-size: 1.4rem;\n  margin: 24px 0 16px 0;\n  font-weight: 600;\n}\n\n.score-block {\n  margin-bottom: 28px;\n}\n\n.score-question {\n  color: #212121;\n  font-size: 1.3rem;\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.score-list {\n  margin: 0 0 12px 0;\n  padding-left: 28px;\n  font-size: 1.2rem;\n}\n\n.score-list li {\n  margin-bottom: 8px;\n  line-height: 1.7;\n}\n\n/* Style for paragraphs after score questions (like \"Why is this graph important?\" sections) */\n.score-question + p {\n  font-size: 1.2rem;\n  line-height: 1.7;\n  color: #616161;\n  margin-bottom: 16px;\n}\n\n/* Style for all paragraphs in the guide to ensure consistent sizing */\n.guide-container.document-style p {\n  font-size: 1.2rem;\n  line-height: 1.7;\n  color: #616161;\n  margin-bottom: 16px;\n}\n\n.highlight {\n  background: #e8f0fe;\n  color: #1a73e8;\n  font-weight: 600;\n  padding: 0 4px;\n  border-radius: 3px;\n}\n\n.note {\n  display: inline-block;\n  background: #e0f2f1;\n  color: #00796b;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 1.1rem;\n  margin-top: 8px;\n}\n\n@media (max-width: 1800px) {\n  .guide-container.document-style {\n    max-width: 98vw;\n    padding: 24px 4vw 36px 4vw;\n  }\n  .guide-img {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 900px) {\n  .guide-container.document-style {\n    padding: 24px 4vw 32px 4vw;\n  }\n  .manual-title {\n    font-size: 2.4rem;\n  }\n  .section-heading {\n    font-size: 1.6rem;\n  }\n  .guide-img {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 600px) {\n  .guide-container.document-style {\n    padding: 10px 2vw 20px 2vw;\n  }\n  .manual-title {\n    font-size: 1.6rem;\n  }\n  .section-heading {\n    font-size: 1.3rem;\n  }\n  .page-title {\n    font-size: 1.2rem;\n  }\n  .subsection-title {\n    font-size: 1.1rem;\n  }\n  .score-question {\n    font-size: 1.1rem;\n  }\n  .score-list {\n    font-size: 1.05rem;\n  }\n  /* Update paragraph sizes for mobile */\n  .guide-container.document-style p {\n    font-size: 1.05rem;\n  }\n  .score-question + p {\n    font-size: 1.05rem;\n  }\n  .guide-img {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n/* Google Translate Widget Styles */\n.translate-section {\n  margin-bottom: 20px;\n  text-align: center;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 10px;\n  border: 1px solid #e9ecef;\n}\n\n.translate-section #google_translate_element {\n  display: inline-block;\n}\n\n.translate-section .goog-te-gadget {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;\n  font-size: 14px !important;\n}\n\n.translate-section .goog-te-gadget .goog-te-combo {\n  padding: 8px 12px;\n  border: 2px solid #1a73e8;\n  border-radius: 6px;\n  background: white;\n  color: #212121;\n  font-size: 14px;\n  cursor: pointer;\n  outline: none;\n  transition: all 0.3s ease;\n}\n\n.translate-section .goog-te-gadget .goog-te-combo:hover {\n  border-color: #00796b;\n  box-shadow: 0 2px 8px rgba(26, 115, 232, 0.2);\n}\n\n.translate-section .goog-te-banner-frame {\n  display: none !important;\n}\n\n.translate-section .goog-te-menu-value {\n  color: #212121 !important;\n}\n\n/* Language Selector Styles */\n.language-selector {\n  margin-bottom: 30px;\n  text-align: center;\n}\n\n.language-tabs {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.language-tab {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  border: 2px solid #e9ecef;\n  background: #efefef;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1rem;\n  font-weight: 500;\n  color: #616161;\n  min-width: 120px;\n  justify-content: center;\n}\n\n.language-tab:hover {\n  border-color: #1a73e8;\n  color: #1a73e8;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.2);\n}\n\n.language-tab.active {\n  background: #1a73e8;\n  border-color: #1a73e8;\n  color: white;\n  box-shadow: 0 4px 15px rgba(26, 115, 232, 0.3);\n}\n\n.language-tab .flag {\n  font-size: 1.2rem;\n}\n\n.language-tab .lang-name {\n  font-weight: 600;\n}\n\n.guide-title {\n  text-align: center;\n  color: #212121;\n  font-size: 2.5rem;\n  margin-bottom: 20px;\n  font-weight: 700;\n}\n\n.guide-intro {\n  text-align: center;\n  font-size: 1.2rem;\n  color: #616161;\n  margin-bottom: 40px;\n  padding: 20px;\n  background: #fff;\n  border-radius: 10px;\n  border-left: 4px solid #1a73e8;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.guide-section {\n  margin-bottom: 40px;\n  padding: 30px;\n  background: #f8f9fa;\n  border-radius: 12px;\n  border: 1px solid #e9ecef;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.guide-section:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n}\n\n.guide-section h2 {\n  color: #212121;\n  font-size: 1.8rem;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 3px solid #1a73e8;\n  display: inline-block;\n}\n\n.graph-explanation h3 {\n  color: #212121;\n  font-size: 1.3rem;\n  margin: 20px 0 10px 0;\n  font-weight: 600;\n}\n\n.graph-explanation p {\n  color: #616161;\n  font-size: 1.1rem;\n  margin-bottom: 15px;\n}\n\n.graph-explanation ul {\n  list-style: none;\n  padding-left: 0;\n}\n\n.graph-explanation ul li {\n  padding: 8px 0;\n  color: #616161;\n  font-size: 1rem;\n  position: relative;\n  padding-left: 25px;\n}\n\n.graph-explanation ul li:before {\n  content: \"•\";\n  color: #1a73e8;\n  font-weight: bold;\n  font-size: 1.5rem;\n  position: absolute;\n  left: 0;\n  top: 5px;\n}\n\n.graph-explanation ul li strong {\n  color: #212121;\n  font-weight: 600;\n}\n\n.tips-section {\n  background: #00796b;\n  color: white;\n  padding: 25px;\n  border-radius: 10px;\n  margin-top: 20px;\n}\n\n.tips-section ul {\n  list-style: none;\n  padding-left: 0;\n}\n\n.tips-section ul li {\n  padding: 10px 0;\n  font-size: 1.1rem;\n  position: relative;\n  padding-left: 30px;\n}\n\n.tips-section ul li:before {\n  content: \"💡\";\n  position: absolute;\n  left: 0;\n  top: 8px;\n}\n\n.tips-section ul li strong {\n  font-weight: 600;\n  color: #fff;\n}\n\n.guide-footer {\n  margin-top: 40px;\n  padding: 25px;\n  background: #e8f0fe;\n  border-radius: 10px;\n  border-left: 4px solid #1a73e8;\n  text-align: center;\n}\n\n.guide-footer p {\n  color: #1a73e8;\n  font-size: 1.1rem;\n  margin: 0;\n}\n\n.guide-footer strong {\n  color: #212121;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .guide-container {\n    padding: 20px;\n    margin: 10px;\n  }\n  \n  .guide-title {\n    font-size: 2rem;\n  }\n  \n  .guide-section {\n    padding: 20px;\n  }\n  \n  .guide-section h2 {\n    font-size: 1.5rem;\n  }\n  \n  .graph-explanation h3 {\n    font-size: 1.2rem;\n  }\n\n  .language-tabs {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .language-tab {\n    width: 200px;\n  }\n\n  .translate-section {\n    padding: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .biweekly-guide {\n    padding: 10px;\n  }\n  \n  .guide-container {\n    padding: 15px;\n  }\n  \n  .guide-title {\n    font-size: 1.8rem;\n  }\n  \n  .guide-intro {\n    font-size: 1rem;\n    padding: 15px;\n  }\n\n  .language-tab {\n    width: 180px;\n    padding: 10px 15px;\n    font-size: 0.9rem;\n  }\n\n  .language-tab .flag {\n    font-size: 1rem;\n  }\n\n  .translate-section .goog-te-gadget .goog-te-combo {\n    font-size: 12px;\n    padding: 6px 10px;\n  }\n}\n\n.graph-img {\n    display: block;\n    margin: 32px auto;\n    width: 600px;\n    max-width: 100%;\n    height: auto;\n    border-radius: 12px;\n    box-shadow: 0 2px 12px rgba(60,72,88,0.10);\n}\n\n.color-swatch {\n  display: inline-block;\n  width: 28px;\n  height: 16px;\n  border-radius: 4px;\n  margin: 0 8px 0 6px;\n  vertical-align: middle;\n  box-shadow: 0 1px 4px rgba(60,72,88,0.10);\n  border: 1px solid #e0e0e0;\n}\n.dark-blue { background: #1a237e; }\n.light-blue { background: #90caf9; }\n.faint-blue { background: #e3f2fd; }\n.orange-brown { background: #bcaaa4; }\n.gray-dash { background: repeating-linear-gradient(90deg, #bdbdbd, #bdbdbd 6px, #fff 6px, #fff 12px); } "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
